import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";
import ContactLetterFile from "./ContactLetterFile";
import { getContactData } from "../../services/queries/getContactData";
import Preloader from "../../components/Preloader";

import Logo from "../../assets/images/logos/new-logo1.png";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

const ContactFile = () => {
  const intl = useIntl();
  const params = useParams();

  const [contactData, setContactData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getContactData(params.registrationId).then((res) => {
      setContactData(res.data);
      setLoading(false);
    }).catch((err) => {
      console.log(err);
      setLoading(false);
    });
  }, [params.registrationId]);

  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
      />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle={intl.formatMessage({ id: "COMMON.CONTACT_LETTER" })} />

          {!loading ? <ContactLetterFile contactData={contactData} /> : <Preloader />}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default ContactFile;
